import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { ToggleColorModeProvider } from "./styles/themes/default";
import { ToastContainer } from "react-toastify";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <>
    <ToastContainer autoClose={4000} closeOnClick theme="colored" />
    <ToggleColorModeProvider>
      <App />
    </ToggleColorModeProvider>
  </>
);
